module.exports = __webpack_public_path__ + "static/img/news3.c452db4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/news3.jpg
// module id = R9H5
// module chunks = 1